export const KEY = "758e3b48372844a68c5f09cbd611e6cf";
export const APIURL = "https://rawg.io/api/";
export const TYPES = ["games", "creators", "genres", "platforms",'publishers'];
export const [games, creators, genres, platforms,publishers] = TYPES;
